document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.joe-hover-card_container');

  // 创建视口观察器
  const carouselObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        initCarousel(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '200px',
    threshold: 0.1
  });
  
  // 开始观察所有轮播图
  carousels.forEach(carousel => {
    carouselObserver.observe(carousel);
  });
  
  function initCarousel(carousel){
    const sectionId = carousel.id.replace('hover-card_container-', '');
    const itemsContainer = carousel.querySelector('.joe-hover-card_items'); 
    const items = carousel.querySelectorAll('.joe-hover-card_item');
    const prevButton = carousel.querySelector('.joe-hover-card_prev'); 
    const nextButton = carousel.querySelector('.joe-hover-card_next'); 

    // 计算滚动距离
    const cardNumber = parseInt(itemsContainer.getAttribute("data-slider-cards")) || 1;
    const cardElem = itemsContainer.querySelector('div.joe-hover-card_item');
    if (!cardElem) return;
    
    const cardWidth = cardElem.offsetWidth;
    const gap = parseInt(window.getComputedStyle(itemsContainer).columnGap) || 0;
    const scrollDistance = (cardWidth + gap) * cardNumber;
    
    // 显示导航按钮
    if (nextButton) {
      nextButton.style.display = 'block';
      nextButton.addEventListener('click', currentNextHandler);
    }
    
    if (prevButton) {
      prevButton.style.display = 'block';
      prevButton.addEventListener('click', currentPrevHandler);
    }

    function updatScrollListener(slider) {
      let scrollTimeout;
      const scrollListener = function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          slider.removeEventListener('scroll', scrollListener);
        }, 150);
      };
      slider.addEventListener('scroll', scrollListener);
    }
    
    function currentNextHandler() {
      updatScrollListener(itemsContainer);
      itemsContainer.scrollBy({
        left: scrollDistance,
        behavior: 'smooth'
      });
    }
    
    function currentPrevHandler() {
      updatScrollListener(itemsContainer);
      itemsContainer.scrollBy({
        left: -scrollDistance,
        behavior: 'smooth'
      });
    }

    // 导航条相关代码
    const videoScrollContainer = itemsContainer;
    const videoItems = items;
    const navBarContainer = carousel.querySelector('.joe-hover-card_nav');
    if (!navBarContainer) return;
    
    const navBar = navBarContainer.querySelector('.joe-hover-card_nav-bar');
    if (!navBar) return;
     
    const totalvideoItems = videoItems.length;
    
    // 正确计算导航条宽度和位置
    const navContainerWidth = navBarContainer.offsetWidth;
    const navBarWidth = navContainerWidth / totalvideoItems;
    
    // 设置导航条初始宽度
    navBar.style.width = `${navBarWidth}px`;
    
    // 实时更新导航条位置的函数，修复滚动条计算问题
    function updateNavBarPosition() {
      // 获取容器样式，计算padding
      const containerStyle = window.getComputedStyle(videoScrollContainer);
      const paddingLeft = parseInt(containerStyle.paddingLeft) || 0;
      const paddingRight = parseInt(containerStyle.paddingRight) || 0;
      const totalPadding = paddingLeft + paddingRight;
      
      // 调整后的总滚动宽度（减去padding）
      const adjustedScrollWidth = videoScrollContainer.scrollWidth - videoScrollContainer.clientWidth - totalPadding;
      
      // 当前滚动位置，考虑左侧padding的影响
      const adjustedScrollLeft = videoScrollContainer.scrollLeft;
      
      // 计算滚动百分比
      const scrollPercent = adjustedScrollWidth > 0 ? adjustedScrollLeft / adjustedScrollWidth : 0;
      
      // 计算导航条可移动的最大距离
      const maxNavTravel = navContainerWidth - navBarWidth;
      
      // 根据滚动百分比设置导航条位置
      const navPosition = Math.max(0, Math.min(maxNavTravel, scrollPercent * maxNavTravel));
      
      navBar.style.left = `${navPosition}px`;
      
      // 调试信息
      // console.log(`总宽度: ${adjustedScrollWidth}, 当前位置: ${adjustedScrollLeft}, 百分比: ${scrollPercent}, 导航位置: ${navPosition}`);
    }
    
    // 初始化导航条位置
    setTimeout(updateNavBarPosition, 100);
    
    // 添加滚动事件监听，实时更新导航条位置
    videoScrollContainer.addEventListener('scroll', function() {
      // 立即更新导航条位置
      requestAnimationFrame(updateNavBarPosition);
    }, { passive: true });
    
    // 窗口大小变化时重新计算
    window.addEventListener('resize', function() {
      const navContainerWidth = navBarContainer.offsetWidth;
      const navBarWidth = navContainerWidth / totalvideoItems;
      navBar.style.width = `${navBarWidth}px`;
      updateNavBarPosition();
    });
    
    // 移动端滑动检测和内容显示/隐藏功能
    if (window.innerWidth <= 768) {
      initMobileScrollBehavior(carousel, items);
    }
  }
  
  // 移动端滑动检测函数 - 实现交替检测上下滑动效果
  function initMobileScrollBehavior(carousel, items) {
    // 滚动跟踪变量
    let lastScrollY = window.scrollY;
    let scrollThreshold = 15; // 减小滑动阈值为15px
    let scrollTimeoutId = null;
    
    // 状态变量 - 跟踪当前应该检测哪个方向
    let detectingDownScroll = true; // true=检测向下滚动，false=检测向上滚动
    let contentVisible = false; // 跟踪内容是否可见
    
    // 创建一个观察器，监测卡片是否在视口中
    const cardsObserver = new IntersectionObserver((entries) => {
      let hasVisibleCard = false;
      
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          hasVisibleCard = true;
        }
      });
      
      // 初始化检查
      if (hasVisibleCard && !contentVisible && !detectingDownScroll) {
        // 如果卡片可见且内容应该可见，但实际不可见，那么显示内容
        showCardContents();
        contentVisible = true;
      }
    }, {
      threshold: 0.3 // 至少30%的卡片可见才触发
    });
    
    // 开始观察所有卡片
    items.forEach(item => {
      cardsObserver.observe(item);
    });
    
    // 监听页面滚动
    window.addEventListener('scroll', () => {
      // 防抖处理
      clearTimeout(scrollTimeoutId);
      
      scrollTimeoutId = setTimeout(() => {
        const scrollY = window.scrollY;
        const scrollDiff = scrollY - lastScrollY;
        
        // 判断滚动方向和是否超过阈值
        if (Math.abs(scrollDiff) >= scrollThreshold) {
          if (scrollDiff > 0 && detectingDownScroll) {
            // 向下滚动，且当前正在检测向下滚动
            console.log('检测到向下滚动');
            showCardContents();
            contentVisible = true;
            detectingDownScroll = false; // 切换为检测向上滚动
            console.log('现在开始检测向上滚动');
          } else if (scrollDiff < 0 && !detectingDownScroll) {
            // 向上滚动，且当前正在检测向上滚动
            console.log('检测到向上滚动');
            hideCardContents();
            contentVisible = false;
            detectingDownScroll = true; // 切换回检测向下滚动
            console.log('现在开始检测向下滚动');
          }
          // 其他情况不处理
        }
        
        lastScrollY = scrollY;
      }, 50); // 50ms的防抖延迟
    }, { passive: true });
    
    // 显示所有卡片内容
    function showCardContents() {
      items.forEach(item => {
        item.classList.add('joe-hover-card_item-show');
      });
    }
    
    // 隐藏所有卡片内容
    function hideCardContents() {
      items.forEach(item => {
        item.classList.remove('joe-hover-card_item-show');
      });
    }
    
    // 初始化状态
    function initializeState() {
      const carouselRect = carousel.getBoundingClientRect();
      
      // 如果卡片容器可见度高，设为已显示状态
      if (carouselRect.top < window.innerHeight * 0.5 && 
          carouselRect.bottom > window.innerHeight * 0.5) {
        showCardContents();
        contentVisible = true;
        detectingDownScroll = false; // 已显示，接下来检测向上滚动
        console.log('初始化: 内容已显示，准备检测向上滚动');
      } else {
        hideCardContents();
        contentVisible = false;
        detectingDownScroll = true; // 未显示，接下来检测向下滚动
        console.log('初始化: 内容已隐藏，准备检测向下滚动');
      }
    }
    
    // 执行初始化
    setTimeout(initializeState, 300);
  }
});